/**
 * Admin 사이트 > 문의. 라우트 admin.php site.contacts 와 동기화.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

const CTRL_TAG = "AdminContactController";

export const AdminContactController = {
    index(): void {
        noop(CTRL_TAG, "index");
    },
    show(): void {
        noop(CTRL_TAG, "show");
    },
};
